import {
  CurrentAttributes,
  Maybe,
  SetpointProfile,
  MyThermostat,
} from '../types';
import { convertLimitTemperature } from '../../../util/convert-temp-units';
import { TemperatureUnit } from '../../../../../system/models/temperatureUnits';
import { deviceDefaultLimits } from './limit-domains';

export interface LimitProfileAssignments {
  unitProfileId?: Maybe<string>;
  propertyProfileId?: Maybe<string>;
}

export const configureBaseSetpointLimits = (
  settings: CurrentAttributes,
  preferredUnits: TemperatureUnit,
  unitSetpointProfile?: Maybe<SetpointProfile>,
  propertySetpointProfile?: Maybe<SetpointProfile>,
  device?: MyThermostat,
  assignments?: LimitProfileAssignments,
): CurrentAttributes => {
  let profile = unitSetpointProfile ?? propertySetpointProfile;
  let basis: CurrentAttributes['setpointLimitBasis'] = unitSetpointProfile
    ? 'unit'
    : propertySetpointProfile
      ? 'property'
      : 'default';
  if (assignments?.unitProfileId) {
    profile =
      assignments.unitProfileId === '0' ? undefined : unitSetpointProfile;
    basis =
      assignments.unitProfileId === '0'
        ? 'default'
        : profile
          ? 'unit'
          : 'unavailable';
  } else if (!unitSetpointProfile && assignments?.propertyProfileId) {
    profile =
      assignments.propertyProfileId === '0'
        ? undefined
        : propertySetpointProfile;
    basis =
      assignments.propertyProfileId === '0'
        ? 'default'
        : profile
          ? 'property'
          : 'unavailable';
  }
  const defaults = basis === 'unavailable' ? {} : deviceDefaultLimits(device);
  if (!profile && !Object.keys(defaults).length) basis = 'unavailable';
  return {
    ...settings,
    setpointLimitBasis: basis,
    baseMaxCoolSetpointLimit: convertLimitTemperature(
      profile ? profile.cool?.max : defaults.maxCoolSetpointLimit,
      preferredUnits,
    ),
    baseMaxHeatSetpointLimit: convertLimitTemperature(
      profile ? profile.heat?.max : defaults.maxHeatSetpointLimit,
      preferredUnits,
    ),
    baseMinCoolSetpointLimit: convertLimitTemperature(
      profile ? profile.cool?.min : defaults.minCoolSetpointLimit,
      preferredUnits,
    ),
    baseMinHeatSetpointLimit: convertLimitTemperature(
      profile ? profile.heat?.min : defaults.minHeatSetpointLimit,
      preferredUnits,
    ),
  };
};
